import { Box, Card, Container, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { News } from '../config/types';
import { Link } from 'react-router-dom';


export const host = process.env.REACT_APP_TVAPP_SERVER_HOST;

const Lesson = () => {
    const [list1, setList1] = useState<News[]>([])
    const [list2, setList2] = useState<News[]>([])
    const [list3, setList3] = useState<News[]>([])

    const getNewsList = async () => {
        const url = host + '/data/api.tvAppOpenApi/getNewsList?mark=%E8%AF%BE%E7%A8%8B%E4%BD%93%E7%B3%BB';


        const data = {};

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const responseData = await response.json();


            if (responseData.code === 1) {
                fillNewsList(responseData.data.list);
            }

            console.log(responseData);
        } catch (error) {
            console.error(error);
        }
    }

    const fillNewsList = (lists: News[]) => {
        const list1 = [];
        const list2 = [];
        const list3 = [];
        for (let i = 0; i < lists.length; i++) {
            const item = lists[i];
            if (i % 5 === 0) {
                list1.push(item);
            }
            if (i % 5 === 1 || i % 5 === 2) {
                list2.push(item);
            }

            if (i % 5 === 3 || i % 5 === 4) {
                list3.push(item);
            }
        }

        setList1(list1);
        setList2(list2);
        setList3(list3);
    }

    useEffect(() => {
        getNewsList();
    }, [])

    return <Layout>
        {/* page content */}
        <div className="w3l-innerblock">
        </div>
        <section className="w3l-content-4 py-5 classinfo" id="ab">
            <div className="content-4-main py-lg-5 py-md-4">
                <div className="container">
                    <div className="ab-info-in row">
                        <div className="ab-min-left col-lg-6">
                            <div className="title-content text-left">
                                <h3 className="title-subhny title-class34">米罗涂鸦班 - 绘画表现：感受艺术时期</h3>
                                <h3 className="title-w3l pr-lg-5">美学启蒙【3-4岁】</h3>
                                <Box className='class-box class34'>
                                    <h5>教学分析</h5>
                                    <p>思维模式处于直觉行动思维阶段动作是思维的起点，动作停止思维。要通过重复动作来获得经验，这个阶段手脑协调锻炼是重点</p>

                                    <h5>教学设计</h5>
                                    <p>在孩子们课堂上要特别重视色彩认识和训练肩部大动作，美术形式多样化以及综合材料的运用和丰富性</p>
                                </Box>
                                <p>
                                    1、能认识8种原色，可以使用原色与生活物品的固有色对应<br></br>
                                    2、认识点线面，可以使用点线面简单的组织画面<br></br>
                                    3、认识黑白灰，可以使用黑白灰简单的组织画面<br></br>
                                    4、认识圆形、三角形、方形，可以利用圆形、三角形和方形进行简单的组织画面<br></br>
                                    5、认识空间对比关系，包括大小、高低、长短、胖瘦、内外前后等空间对比<br></br>
                                    6、体验丰富的质感，尝试使用颜料的薄厚、材料的不同肌理物象的软硬感进行创作表达<br></br>
                                </p>
                            </div>
                        </div>
                        <div className="ab-min-right col-lg-6 pl-lg-5">
                            <img alt='' className='img-fluid' src="/bloommeta/class34bg.png" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div className="w3l-agent-block py-5">
            <div className="container">
                <div className="ab-info-in row">
                    <div className="ab-min-left col-lg-6">
                        <div className="title-content text-left">
                            <h3 className="title-subhny title-class56">莫奈色彩班 - 绘画表现：情节表达时期</h3>
                            <h3 className="title-w3l pr-lg-5">美学探索【5-6岁】</h3>
                            <Box className='class-box class56'>
                                <h5>教学分析</h5>
                                <p>5-6岁儿童处于前运算阶段的一个部分儿童的符号思维不断发展，最重要的发展是空间概念的发展。</p>

                                <h5>教学设计</h5>
                                <p>在孩子们课堂上要特别重视孩子肢体动作与精细动作的练习，在创作过程中会涉及到方位确定训练，色彩感知训练手指灵活度训练等</p>
                            </Box>
                            <p>
                                1、认识12种及以上色彩，认识冷暖色，并初步尝试色彩调和<br></br>
                                2、认识对比色、邻近色，可以在画面中综合运用对比色与邻近色<br></br>
                                3、理解点线面，可以使用点线面有规律的组织画面进行装饰创作<br></br>
                                4、可以运用点线面表现人物的五官和身体动态造型<br></br>
                                5、理解黑白灰，可以在画面中表现黑白灰的关系<br></br>
                                6、建立初步构图和空间感知: 疏密、主次、遮挡内外、近大远小<br></br>
                                7、认识半圆形、椭圆形，可以利用半圆形、椭圆形，拥有利用造型组合新事物的能力

                            </p>
                        </div>
                    </div>
                    <div className="ab-min-right col-lg-6 pl-lg-5">
                        <img alt='' className='img-fluid' src="/bloommeta/class56bg.png" />
                    </div>
                </div>
            </div>
        </div>


        <section className="w3l-content-4 py-5 classinfo" id="ab">
            <div className="content-4-main py-lg-5 py-md-4">
                <div className="container">
                    <div className="ab-info-in row">
                        <div className="ab-min-left col-lg-6">
                            <div className="title-content text-left">
                                <h3 className="title-subhny title-class78">毕加索造型班 - 绘画表现：审美需求时期</h3>
                                <h3 className="title-w3l pr-lg-5">造型创意【7-8岁】</h3>
                                <Box className='class-box class78'>
                                    <h5>教学分析</h5>
                                    <p>现在阶段对三维空间的认识开始萌芽有了把自己看到的立体物体表达在画面上的需要</p>

                                    <h5>教学设计</h5>
                                    <p>刚刚进入校园或为升入小学做准备的阶段，我们的课堂设计会让他们具备能够将知识串联起来的逻辑思维，通过一系列的引导让大家不仅仅学会当节课绘画知识，还能扩展主题知识面</p>
                                </Box>
                                <p>
                                    1、认识并运用冷暖色，可以感受色彩中的相对冷暖并进行创作表达<br></br>
                                    2、体验丰富的材料形式，根据材料的不同肌理物象的软硬感进行创作表达<br></br>
                                    3、学习从整体到局部的观察，并通过疏密大小组织画面表达情绪<br></br>
                                    4、学习多种构图形式，并运用于创作表达中<br></br>
                                    5、感受平面到立体的空间转变，用综合材料进行空间的创作表达<br></br>
                                    6、感受多元的绘画形式，进行自我表达
                                </p>
                            </div>
                        </div>
                        <div className="ab-min-right col-lg-6 pl-lg-5">
                            <img alt='' className='img-fluid' src="/bloommeta/class78bg.png" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div className="w3l-agent-block py-5">
            <div className="container">
                <div className="ab-info-in row">
                    <div className="ab-min-left col-lg-6">
                        <div className="title-content text-left">
                            <h3 className="title-subhny title-class910">塞尚少儿大师班 - 绘画表现：写实需求时期</h3>
                            <h3 className="title-w3l pr-lg-5">视觉写实【9-10岁】</h3>
                            <Box className='class-box class910'>
                                <h5>教学分析</h5>
                                <p>儿童经历了两个年龄段的涂涂画画有了一定的经验和体会，是展开想象的黄金阶段对造型有了较为明显的认识和理解线条变得较为流畅表达意识的能力有所提高，以自我为中心的表现更加体现在画面上，喜欢鲜艳的对比用色</p>

                                <h5>教学设计</h5>
                                <p>在学生拥有初步 “看〞画面表面信息时帮助学生分解内部画面构成因素一点滴的积累学生对于名画内部构成的认知</p>
                            </Box>
                            <p>
                                1、能熟练掌握颜色调和的技法<br></br>
                                2、能认识和使用环境色和固有色进行绘画<br></br>
                                3、能观察事物的动态，初步认识比例关系，感受生命的动态之美<br></br>
                                4、了解学习设计美学的基础方法: 随形联想、版式设计、字体设计与点、线、面元素结合，表达创作想法<br></br>
                                5、通过结合综合材料感受肌理变化，学习如何制作肌理表现画面的质感<br></br>
                                6、了解艺术创作中空间表现的多样性运用综合材料尝试创作具有空间感的作品<br></br>
                                7、通过写生等方法进一步提升学生对细节的观察力、对形体特征的表现力造型能力<br></br>
                                8、通过认识4位艺术家与创作生涯提高对于艺术的欣赏能力和多元的创作方式<br></br>


                            </p>
                        </div>
                    </div>
                    <div className="ab-min-right col-lg-6 pl-lg-5">
                        <img alt='' className='img-fluid' src="/bloommeta/class910bg.png" />
                    </div>
                </div>
            </div>
        </div>

        <section className="w3l-content-4 py-5 classinfo" id="ab">
            <div className="content-4-main py-lg-5 py-md-4">
                <div className="container">
                    <div className="ab-info-in row">
                        <div className="ab-min-left col-lg-6">
                            <div className="title-content text-left">
                                <h3 className="title-subhny title-class11">专业课程工作室 - 绘画表现：专业突破时期</h3>
                                <h3 className="title-w3l pr-lg-5">专业发展【10+】</h3>
                                <Box className='class-box class11'>
                                    <h5>教学分析</h5>
                                    <p>儿童经历了两个年龄段的涂涂画画有了一定的经验和体会，是展开想象的黄金阶段对造型有了较为明显的认识和理解线条变得较为流畅表达意识的能力有所提高，以自我为中心的表现更加体现在画面上喜欢鲜艳的对比用色</p>

                                    <h5>教学设计</h5>
                                    <p>如何更准确的，〞看〞到绘画的物象从外部的轮廓到内部的结构，从物象形体的本质，到光影影响的现象</p>
                                </Box>
                                <p>
                                    1、可以认知到形状、体积和空间之间的组合关系理解具象事物是由这三个元素的组合<br></br>
                                    2、认识光影、结构、质感三大方面，有一定的深入塑造的能力<br></br>
                                    3、初步了解色彩的明度、纯度，对比同类色和补色会使用这些色彩关系进行画面组合<br></br>
                                    4、了解三个构图方式<br></br>
                                    5、会使用三个方法表达画面的空间<br></br>
                                    6、认识和了解4位大师的作品风格<br></br>
                                </p>
                            </div>
                        </div>
                        <div className="ab-min-right col-lg-6 pl-lg-5">
                            <img alt='' className='img-fluid' src="/bloommeta/class11bg.png" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div className="w3l-agent-block py-5">
            <div className="container">
                <div className="ab-info-in row">
                    <div className="ab-min-left col-lg-6">
                        <div className="title-content text-left">
                            <h3 className="title-subhny title-class11_">专业课程工作室 - 绘画表现：专业突破时期</h3>
                            <h3 className="title-w3l pr-lg-5">课程体系【冰山理论】</h3>
                            <p>
                                美是看不见的竞争力，艺术、 主活各方面，皆有看不见的审美 水准时刻衡量你，甚至大多是不经意和下意识的。这个看"不见的标准，带给人生最多的幸福和愉悦，是生活方式，是人生的方式，人生幸福必需的组成部分。有时候不是孩子从我们这里习得了关于美的习惯而是他自己带来的对美的感知道没有被限制掉，所有的父母和教育者，都需要带着敬畏的心
                            </p>
                        </div>
                    </div>
                    <div className="ab-min-right col-lg-6 pl-lg-5">
                        <img alt='' className='img-fluid' src="/bloommeta/class11+bg.png" />
                    </div>
                </div>
            </div>
        </div>

        <section className="w3l-agent-block py-5" id="news">
            <div className="container py-lg-5 py-md-5 py-2">
                <div className="row">
                    <div className="col-lg-4 news-left">
                        <h6 className="title-subhny">Explore</h6>
                        <h3 className="title-w3l">发现更多课程</h3>
                        <p className="my-3"> 脚踏实地、认认真真上好每一节课
                            这是每一个花儿和马嗒教师
                            基本的价值观
                        </p>
                        <>
                            {list1 && list1.length > 0 ? (
                                list1.map((v, index) =>
                                    <div className="w3l-news-gd mt-5">
                                        <Link to={'/lesson/detail?id=' + v.id}><img src={v.cover} alt="" className="radius-image img-fluid" /></Link>
                                        <div className="w3l-news-gd-inf mt-4">
                                            <h4>
                                                <Link to={'/lesson/detail?id=' + v.id} className="news-link">{v.name}</Link>
                                            </h4>
                                        </div>
                                    </div>
                                )
                            ) : (null)}
                        </>



                    </div>
                    <div className="col-lg-8 news-left mt-lg-0 mt-5 pl-lg-5">
                        <div className="row ">
                            <div className="col-md-6 news-gd-1 mt-lg-5 pt-lg-5 px-lg-4">
                                <>
                                    {list2 && list2.length > 0 ? (
                                        list2.map((v, index) =>
                                            <div className="w3l-news-gd mb-5">
                                                <Link to={'/lesson/detail?id=' + v.id}><img src={v.cover} alt="" className="radius-image img-fluid" /></Link>
                                                <div className="w3l-news-gd-inf mt-4">
                                                    <h4>
                                                        <Link to={'/lesson/detail?id=' + v.id} className="news-link">{v.name}</Link>
                                                    </h4>
                                                </div>
                                            </div>
                                        )
                                    ) : (null)}
                                </>


                            </div>
                            <div className="col-md-6 news-gd-1 px-lg-4">
                                <>
                                    {list3 && list3.length > 0 ? (
                                        list3.map((v, index) =>

                                            <div className="w3l-news-gd mb-5">
                                                <Link to={'/lesson/detail?id=' + v.id}><img src={v.cover} alt="" className="radius-image img-fluid" /></Link>
                                                <div className="w3l-news-gd-inf mt-4">
                                                    <h4>
                                                        <Link to={'/lesson/detail?id=' + v.id} className="news-link">{v.name}</Link>
                                                    </h4>
                                                </div>
                                            </div>
                                        )
                                    ) : (null)}
                                </>


                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </section>
        {/* page content end*/}
    </Layout>
}
export default Lesson;